import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-00cd8ac7"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "Zone"
};
import BaseRule from '../BaseRule.vue';
import { computed } from 'vue';
export default {
  __name: 'AgeLimit',
  props: ['index', 'item', 'data'],
  setup(__props) {
    const props = __props;
    const data = computed(() => props.data);
    const index = computed(() => props.index);
    const item = computed(() => props.item);
    const word = {
      name: 'AgeLimit'
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      return _openBlock(), _createBlock(BaseRule, {
        word: word,
        index: _unref(index),
        data: _unref(data)
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createTextVNode(" 满"), _createVNode(_component_el_input, {
          modelValue: _unref(item).value.one,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(item).value.one = $event),
          modelModifiers: {
            number: true
          },
          class: "input"
        }, null, 8, ["modelValue"]), _createTextVNode("月，备注："), _createVNode(_component_el_input, {
          modelValue: _unref(item).value.two,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(item).value.two = $event),
          class: "input ageLimit"
        }, null, 8, ["modelValue"])])]),
        _: 1
      }, 8, ["index", "data"]);
    };
  }
};